import React, { use, useEffect, useState } from "react";
import useGetApi from "../../services/useGetApi";
import usePost from "../../services/usePost";
import {
  Card,
  Checkbox,
  Radio,
  Input,
  Button,
  Typography,
  Row,
  Col,
  message,
} from "antd";
import { parse } from "tinyduration";
import { useParams } from "react-router-dom";

const { Title, Text } = Typography;

const parseDuration = (duration) => {
  if (!duration) return 0;

  const parsedDuration = parse(duration);
  return (
    (parsedDuration.seconds ?? 0) +
    (parsedDuration.minutes ?? 0) * 60 +
    (parsedDuration.hours ?? 0) * 3600 +
    (parsedDuration.days ?? 0) * 86400 +
    (parsedDuration.weeks ?? 0) * 604800 +
    (parsedDuration.months ?? 0) * 2592000 + // Approximate (30 days)
    (parsedDuration.years ?? 0) * 31536000 // Approximate (365 days)
  );
};

const ConductQuiz = ({ courseId, sectionId, quizId }) => {
  const [quizData, setQuizData] = useState(null);
  const [quizResults, setQuizResults] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [userAnswers, setUserAnswers] = useState({});
  const [correctAnswers, setCorrectAnswers] = useState({});
  const [quizStarted, setQuizStarted] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [userData, setUserData] = useState(null);
  const [userQuizAnswers, setUserQuizAnswers] = useState();
  const [hasSubmittedQuiz, setHasSubmittedQuiz] = useState(false);
  const [quizResultStudentId,setStudentIdQuizResult] = useState(null)

  const {studentId} = useParams()

  // console.log(studentId,'user')

  // get quiz data
  const [isQuizLoading, quizDataError, quizDataResult, getQuizData] = useGetApi(
    `sections/course/${courseId}/section/${sectionId}/quiz/${quizId}`,
    [],
    true
  );

  // get questions data
  const [isQuestionsLoading, questionsError, questionsData, getQuestionsData] =
    useGetApi(
      `sections/course/${courseId}/section/${sectionId}/quiz/${quizId}/questions`,
      [],
      true
    );

  // get quiz result data
  const [
    isQuizResultsLoading,
    quizResultsError,
    quizResultsData,
    getQuizResultsData,
  ] = useGetApi(`quizResults/${userData?.userId}/${courseId}`, [], true);

  const [isPostLoading, postError, postData] = usePost();

  useEffect(() => {
    if(studentId){
      setUserData({ userId: studentId})
    }
    else{
      var userData = localStorage.getItem("userData");
      setUserData(JSON.parse(userData));
    }
  }, [studentId]);

  useEffect(() => {
    getQuizData(
      `sections/course/${courseId}/section/${sectionId}/quiz/${quizId}`
    );
    setQuizStarted(false);
  }, [courseId, sectionId, quizId]);

  useEffect(() => {
    if (quizDataResult) {
      setQuizData(quizDataResult);
    }
  }, [quizDataResult]);

  useEffect(() => {
    fetchQuizResults();
  }, [userData, quizId]);

  const fetchQuizResults = async () => {
    if (!userData) {
      const storedUserData = localStorage.getItem("userData");

      if(studentId){
         setUserData({ userId: studentId})
      }
      else if (storedUserData) {
        setUserData(JSON.parse(storedUserData));
      }
    }
    try {
      const response = await getQuizResultsData(
        `quizResults/${userData?.userId}/${courseId}`
      );
      if (response) {
        if (Array.isArray(response)) {
          let currentQuizResults = response.filter((q) => q.quizId == quizId);
          if (
            currentQuizResults != null &&
            currentQuizResults &&
            Array.isArray(currentQuizResults) &&
            currentQuizResults.length > 0
          ) {
            let highestResult = currentQuizResults[0];

            for (let i = 0; i < currentQuizResults.length; i++) {
              if (
                highestResult.totalObtainedMarks <
                currentQuizResults[i].quizResultsData
              ) {
                highestResult = currentQuizResults[i].quizResultsData;
              }
            }

            setQuizResults(highestResult);
            setUserAnswers(
              highestResult.userAnswers
                ? JSON.parse(highestResult.userAnswers)
                : {}
            );

            setCorrectAnswers(
              highestResult.correctAnswers
                ? JSON.parse(highestResult.correctAnswers)
                : {}
            );

            fetchQuestions();
          } else {
            setQuestions([]);
            setQuizResults(null);
            setUserAnswers({});
            setCorrectAnswers({});
          }
        } else {
          message.error("Failed to fetch quiz results.");
        }
      } else {
        message.error("Failed to fetch quiz results.");
      }
    } catch (error) {
      message.error("Error fetching quiz results.");
    }
  };

  const fetchQuestions = () => {
    getQuestionsData(
      `sections/course/${courseId}/section/${sectionId}/quiz/${quizId}/questions`
    );
  };

  const startQuiz = () => {
    fetchQuestions();
    setQuizStarted(true);
  };

  useEffect(() => {
    if (Array.isArray(quizResultsData)) {
      const filterQuizAnswers = quizResultsData.filter(
        (val) => val.quizId === quizId
      );

      if (filterQuizAnswers.length > 0) {
        fetchQuestions();
      }
      const userAnswersParse = filterQuizAnswers[0]?.userAnswers
        ? JSON.parse(filterQuizAnswers[0]?.userAnswers)
        : [];
      console.log(userAnswersParse, "parse");
      setUserQuizAnswers(userAnswersParse);
    }
  }, [quizResultsData]);

  useEffect(() => {
    if (questionsData) {
      setQuestions(questionsData);
      setTimeLeft(parseDuration(quizData?.duration));
    }
  }, [questionsData]);

  useEffect(() => {
    if (quizStarted && timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [quizStarted, timeLeft]);

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const handleAnswerChange = (questionId, value) => {
    setUserAnswers((prev) => ({
      ...prev,
      [questionId]: value,
    }));
  };

  const validateAnswers = (questions, userAnswers) => {
    // Parse options & answer fields in questions
    const parsedQuestions = questions.map((q) => ({
      ...q,
      options: JSON.parse(q.options), // Convert options from JSON string to array
      answer: JSON.parse(q.answer), // Convert answer from JSON string to array
    }));

    let totalObtainedMarks = 0;
    const correctAnswers = parsedQuestions.map((question) => {
      const correctAnswer = question.answer;
      const userAnswer = Array.isArray(userAnswers[question.id])
        ? [...userAnswers[question.id]]
        : [userAnswers[question.id]]; // Ensure userAnswer is always an array

      // Compare sorted answers (for Multiple Choice)
      const isCorrect =
        JSON.stringify(userAnswer.sort()) ===
        JSON.stringify(correctAnswer.sort());

      if (isCorrect) {
        totalObtainedMarks += Number(
          (quizData.totalMarks / questions.length).toFixed(2)
        );
      }

      return {
        questionId: question.id,
        correctAnswer: correctAnswer,
      };
    });

    const correctAnswersObj = correctAnswers.reduce((acc, curr) => {
      acc[curr.questionId] = curr.correctAnswer;
      return acc;
    }, {});

    return {
      correctAnswers: JSON.stringify(correctAnswersObj),
      userAnswers: JSON.stringify(userAnswers),
      totalMarks: quizData.totalMarks,
      totalObtainedMarks:
        totalObtainedMarks > quizData.totalMarks
          ? quizData.totalMarks
          : totalObtainedMarks.toFixed(0),
      isSubmitted: 1,
      quizId: quizId,
      dateAdded: new Date().toISOString(),
      dateUpdated: new Date().toISOString(),
      userId: userData?.userId,
    };
  };

  const handleSubmit = async () => {
    const result = validateAnswers(questions, userAnswers);
    console.log("Validation Result:", result);

    try {
      const response = await postData(`quizResults/save`, result, true);
      if (response) {
        message.success("Quiz Submitted successfully!");
        setQuizStarted(false);
        fetchQuizResults();
      } else {
        message.error("Failed to submit quiz.");
      }
    } catch (error) {
      message.error("Error submitting quiz.");
    }
  };

  if (isQuizLoading || isQuestionsLoading || isQuizResultsLoading) {
    return <div>Loading...</div>;
  }

  const renderAnswer = (question, index) => {
    const userAnswer = userQuizAnswers[index]?.[question?.id] || [];
    const correctAnswer = JSON.parse(question.answer);
    const isCorrect =
      JSON.stringify(userAnswer.sort()) ===
      JSON.stringify(correctAnswer.sort());

    // console.log(userAnswer,'answer snaswer')

    return (
      <div key={question.id} style={{ marginBottom: "20px" }}>
        <h4>
          {index + 1}. <b>{question.question}</b>
        </h4>

        {/* Show Multiple-choice questions */}
        {question.questionType === "Multiple_choice" && (
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {JSON.parse(question.options).map((option, idx) => (
              <Checkbox
                key={idx}
                disabled
                checked={userAnswer.includes(option)}
              >
                {option}
              </Checkbox>
            ))}
            {isCorrect ? (
              <p className="green-color">Correct Answer</p>
            ) : (
              <p className="red-color">
                Wrong Answer :{correctAnswer.join(", ")}
              </p>
            )}
          </div>
        )}

        {/* Show True/False question */}
        {question.questionType === "Single_choice_And_true/false" && (
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {JSON.parse(question.options).map((option, idx) => (
              <Radio
                key={idx}
                value={option}
                disabled
                checked={userAnswer.includes(option)}
              >
                {option}
              </Radio>
            ))}
            {isCorrect ? (
              <p className="green-color">Correct Answer</p>
            ) : (
              <p className="red-color">
                Wrong Answer :{correctAnswer.join(", ")}
              </p>
            )}
          </div>
        )}

        {/* Show Fill-in-the-blank question */}
        {question.questionType === "Fill_in_the_blank" && (
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <Input
              placeholder="Enter your answer"
              value={userAnswer[0] || ""}
              disabled
            />
            {isCorrect ? (
              <p className="green-color">Correct Answer</p>
            ) : (
              <>
                <p className="red-color">Wrong Answer</p>
                <p className="red-color">
                  Correct answer : {correctAnswer.join(", ")}
                </p>
              </>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <Card title={quizData?.title} style={{ marginBottom: "20px" }}>
      {userQuizAnswers?.length > 0 ? (
        <Row>
          <Col span={24} style={{ marginBottom: "10px", textAlign: "center" }}>
            <div className="">
              <div className="quiz_section_header">
                <div>
                  <h3>{quizData?.title}</h3>
                </div>
                <div className="right">
                  Total questions: {questionsData?.length} | Total marks:{" "}
                  {quizData?.totalMarks}
                </div>
              </div>
              <div className="quiz_page_top">
                <div className="quiz_page_top_content">
                  <h1>Quiz results</h1>
                  <p>Total marks: {quizData?.totalMarks}</p>
                  <p>Passing marks: {quizData?.passMarks}</p>
                  <p>
                    <b className="red-color">Obtained marks:</b>
                    {userQuizAnswers[0]?.totalObtainedMarks}
                  </p>
                </div>
              </div>
              <div className="horizontal_line"></div>
              <div className="quiz_question_div">
                {questionsData.map((question, index) =>
                  renderAnswer(question, index)
                )}
              </div>
            </div>
          </Col>
        </Row>
      ) : (
        <>
          <Row>
            <Col
              span={24}
              style={{ marginBottom: "10px", textAlign: "center" }}
            >
              <Row>
                <Col span={12}>
                  <Title level={4} style={{ textAlign: "left" }}>
                    {quizData?.dripContentRule}
                  </Title>
                </Col>
                <Col span={12}>
                  <Title
                    level={4}
                    style={{ textAlign: "right", width: "100%" }}
                  >
                    {quizStarted && `Time Left: ${formatTime(timeLeft)}`}
                  </Title>
                </Col>
              </Row>

              <Text>
                <strong>Note: </strong>
                {quizData?.dripContentRule}
              </Text>
              <hr style={{ margin: "10px" }} />
              <p>
                <b>Duration:</b> {formatTime(parseDuration(quizData?.duration))}
              </p>
              <p>
                <b>Total Marks:</b> {quizData?.totalMarks}
              </p>
              <p>
                <b>Passing Marks:</b> {quizData?.passMarks}
              </p>

              {quizResults != null &&
                quizResults.totalObtainedMarks != null && (
                  <p>
                    <b>Obtained Marks:</b>
                    {quizResults != null && quizResults.totalObtainedMarks}
                  </p>
                )}

              {!quizStarted && quizResults == null && (
                <Button type="primary" onClick={startQuiz}>
                  Start Quiz
                </Button>
              )}
            </Col>
          </Row>

          {(quizResults != null || quizStarted) && (
            <div style={{ overflowY: "auto" }}>
              {questions.length > 0 &&
                questions.map((question, index) => (
                  <div key={question.id} style={{ marginBottom: "20px" }}>
                    <h3>
                      Question #{index + 1}: {question.question}
                    </h3>
                    {question.questionType === "Multiple_choice" &&
                      JSON.parse(question.options).map((option, idx) => (
                        <Checkbox
                          key={idx}
                          disabled={quizResults != null}
                          onChange={(e) => {
                            const selectedOptions =
                              userAnswers[question.id] || [];
                            if (e.target.checked) {
                              setUserAnswers((prev) => ({
                                ...prev,
                                [question.id]: [...selectedOptions, option],
                              }));
                            } else {
                              setUserAnswers((prev) => ({
                                ...prev,
                                [question.id]: selectedOptions.filter(
                                  (opt) => opt !== option
                                ),
                              }));
                            }
                          }}
                          style={{ display: "block", marginBottom: "8px" }}
                        >
                          {option}
                        </Checkbox>
                      ))}

                    {question.questionType ===
                      "Single_choice_And_true/false" && (
                      <Radio.Group
                        disabled={quizResults != null}
                        onChange={(e) =>
                          handleAnswerChange(question.id, e.target.value)
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        {JSON.parse(question.options).map((option, idx) => (
                          <Radio key={idx} value={option}>
                            {option}
                          </Radio>
                        ))}
                      </Radio.Group>
                    )}

                    {question.questionType === "Fill_in_the_blank" && (
                      <Input
                        disabled={quizResults != null}
                        placeholder="Type your answer"
                        onChange={(e) =>
                          handleAnswerChange(question.id, e.target.value)
                        }
                        style={{ marginTop: "8px" }}
                      />
                    )}

                    {quizResults != null && (
                      <div>
                        <p>
                          <b>Correct Answer:</b> {correctAnswers[question.id]}
                        </p>
                        <p>
                          <b>Your Answer:</b>{" "}
                          {userAnswers[question.id] ?? "No answer provided"}
                        </p>
                      </div>
                    )}
                    <hr />
                  </div>
                ))}

              {quizResults == null && (
                <Button
                  type="primary"
                  onClick={handleSubmit}
                  disabled={Object.keys(userAnswers).length === 0}
                  style={{ marginTop: "16px" }}
                >
                  Submit Quiz
                </Button>
              )}
            </div>
          )}
        </>
      )}
    </Card>
  );
};

export default ConductQuiz;
